<div class="action-co-container container-fluid px-5">
  <!--<div class="action-co-header"><span>{{this.actionCoService.Model.Sujet}}</span></div>-->

  <div class="tabs">
    <button class="btn-back"  *ngIf="!modalContainer" (click)="goBackToPipe()">Retour</button>
    <ng-container *ngFor="let tab of tabs">
      <button *ngIf="tab.Visible" class="q-btn tab-button" [ngClass]="{'tab-select': tab.Active}" (click)="ActiveTab(tab.Type)" [disabled]="tab.Locked"><i [ngClass]="tab.Font"></i>{{tab.Name}}</button>
    </ng-container>
  </div>
  <div class="action-co-body">
    <q-action-co-action *ngIf="dataLoaded && tabs[0].WasOpenedForTheFirstTime"
                        [ngClass]="{'d-none': !tabs[0].Active }"
                        [(model)]=actionCoService.Model
                        [idActionCo]="idActionCo"
                        [Customer]="Customer"
                        [awaitNameCollabo]="awaitNameCollabo"
                        [awaitNameContact]="awaitNameContact"
                        [awaitNameCustomers]="awaitNameCustomers"
                        [dataListCollabo]="dataListCollabo"
                        [dataListContact]="dataListContact"
                        [strDescription]="strDesctiption"
                        (setIdActionCo)="ActionCoCreated($event)">
    </q-action-co-action>

    <!--<q-action-co-modefacturation *ngIf="dataLoaded && tabs[1].WasOpenedForTheFirstTime"
                                 [ngClass]="{'d-none': !tabs[1].Active }"
                                 class="w-100"
                                 [idObjet]="0"
                                 [idClient]="Customer.Id"
                                 [mode] ="mode">
    </q-action-co-modefacturation>-->

    <q-action-co-devis *ngIf="dataLoaded && tabs[1].WasOpenedForTheFirstTime && tabs[1].Visible"
                       [ngClass]="{'d-none': !tabs[1].Active }"                       
                       class="w-100"
                       (setIdActionCo)="ActionCoCreated($event)">
    </q-action-co-devis>

    <q-action-co-calculateur *ngIf="dataLoaded && tabs[2].WasOpenedForTheFirstTime &&tabs[2].Visible"
                             [ngClass]="{'d-none': !tabs[2].Active }"
                             class="w-100">
    </q-action-co-calculateur>

    <q-action-co-ldm *ngIf="dataLoaded && tabs[3].WasOpenedForTheFirstTime &&tabs[3].Visible"
                     [ngClass]="{'d-none': !tabs[3].Active }"
                     class="w-100"
                     (setIdActionCo)="ActionCoCreated($event)">
    </q-action-co-ldm>

    <q-action-co-esign *ngIf="dataLoaded && tabs[4].WasOpenedForTheFirstTime"                       
                       [ngClass]="{'d-none': !tabs[4].Active }"
                       class="w-100"
                       [(model)]=actionCoService.Model>
    </q-action-co-esign>

    <q-action-co-mail *ngIf="dataLoaded && tabs[5].WasOpenedForTheFirstTime"
                      [ngClass]="{'d-none': !tabs[5].Active }"
                      class="w-100 mr-1 ml-1"
                      [(model)]=actionCoService.Model                      
                      (setIdActionCo)="ActionCoCreated($event)">
    </q-action-co-mail>

    <q-action-co-transform *ngIf="dataLoaded && tabs[6].WasOpenedForTheFirstTime"
                           [ngClass]="{'d-none': !tabs[6].Active }"
                           class="w-100"
                           (setIdActionCo)="ActionCoCreated($event)">
    </q-action-co-transform>

    <div *ngIf="!dataLoaded" class="d-flex w-100 justify-content-center m-5">
      <i class="q-c-main fas fa-spinner fa-spin fa-pulse fa-3x"></i>
    </div>
  </div>
</div>
